import axios from "axios";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import TaxInfoModal from "../../../../Components/Host/Modal/TaxInfoModal";
import VatIdModal from "../../../../Components/Host/Modal/VatIdModal";
import { SetMetaTags } from "../../../../Components/Utility/setMetaTags";



function HostTaxes() {
  const [showTaxInfo, setShowTaxInfo] = useState(false);
  const [showVAT, setShowVAT] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const [tax, setTax] = useState({
    tax_country: "",
    vat_no: "",
    registration_name: "",
    country_id: "",
    city_id: "",
    address: "",
    provence_region: "",
    post_code: "",
    additional_info: "",
  });

  // ✅ Ensure only valid tax_country (1,2,3)
  const ensureTaxCountry = (val) => {
    const n = Number(val);
    return [1, 2, 3].includes(n) ? n : 1;
  };

  // ✅ Fetch existing tax info
  const fetchTax = async () => {
    try {
      setLoading(true);
      const res = await axios.get(`${process.env.REACT_APP_API_BASE}/host/get-tax`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      const data = res.data?.data || res.data || {};

      setTax({
        tax_country: ensureTaxCountry(data.tax_country),
        vat_no: data.vat_no || "",
        registration_name: data.registration_name || "",
        country_id: data.country_id || "",
        city_id: data.city_id || "",
        address: data.address || "",
        provence_region: data.provence_region || "",
        post_code: data.post_code || "",
        additional_info: data.additional_info || "",
      });
    } catch (err) {
      console.error("GET /host/get-tax error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTax();
  }, []);

  // ✅ Save (Create or Update)
  const saveTax = async (payload) => {
    try {
      setSaving(true);

      const res = await toast.promise(
        axios.post(`${process.env.REACT_APP_API_BASE}/host/save-tax`, payload, 
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        ),
        {
          loading: "Saving tax details…",
          success: "Tax details saved ✅",
          error: "Failed to save tax details ❌",
        }
      );

      if (res.data?.status === false) {
        throw new Error(res.data?.message || "Save failed");
      }

      await fetchTax();
      return true;
    } catch (e) {
      console.error("POST /host/save-tax error:", e);
      return false;
    } finally {
      setSaving(false);
    }
  };

  // ✅ Inline save handlers
  const handleSaveVAT = () => {
    const payload = { ...tax, tax_country: ensureTaxCountry(tax.tax_country) };
    saveTax(payload);
  };

  const handleSaveAdditionalInfo = () => {
    const payload = { ...tax, tax_country: ensureTaxCountry(tax.tax_country) };
    saveTax(payload);
  };

  return (
    <>
      <section className="mng_bottomss user_allls profiles all_titless myprofiless">

         <SetMetaTags
        title="Tax | Weyfarin"
        description=""
        keywords=""
      />

        <div className="prfo_listst lastsst al_sec_ctxt ac_settingss">
          <div className="row">
            <div className="col-lg-8">
              <div className="discriptionns">
                <h3>Taxes</h3>
              </div>

              <div className="form_al_fildss">
                {/* Tax Payer Info */}
                <div className="ac_seting_are mngspace">
                  <h6>Tax Payer Information</h6>
                  <p>Tax info is required for most countries/regions</p>

                  <button
                    type="button"
                    className="butn_al_areea1"
                    onClick={() => setShowTaxInfo(true)}
                    disabled={saving}
                    style={{ marginTop: 10 }}
                  >
                    {tax.registration_name ? "Edit Tax Info" : "Add Tax Info"}
                  </button>
                </div>

                {/* VAT */}
                <div className="ac_seting_are mngspace">
                  <h6>Value Added Tax (VAT)</h6>
                  <p>If you are VAT-registered, please add your VAT ID.</p>

                  {/* <div className="form-group managess" style={{ maxWidth: 420 }}>
                    <label>VAT Number</label>
                    <input
                      className="form-control"
                      type="text"
                      value={tax.vat_no || ""}
                      onChange={(e) =>
                        setTax((t) => ({ ...t, vat_no: e.target.value }))
                      }
                    />
                  </div> */}

                  <div style={{ display: "flex", gap: 12, marginTop: 10 }}>
                    {/* <button
                      type="button"
                      className="butn_al_areea1"
                      onClick={handleSaveVAT}
                      disabled={saving}
                    >
                      Save VAT
                    </button> */}

                    <button
                      type="button"
                      className="butn_al_areea1"
                      onClick={() => setShowVAT(true)}
                      disabled={saving}
                    >
                      {tax.vat_no ? "Add VAT ID Number" : "Add via Modal"}
                    </button>
                  </div>
                </div>

                {/* Additional info */}
                <div className="ac_seting_are mngspace">
                  <h6>Additional Information (Optional)</h6>
                  <div
                    className="form-group managess mt-3"
                    style={{ maxWidth: 600 }}
                  >
                    <textarea
                      className="form-control"
                      name="additional_info"
                      rows="4"
                      value={tax.additional_info || ""}
                      onChange={(e) =>
                        setTax((t) => ({
                          ...t,
                          additional_info: e.target.value,
                        }))
                      }
                    />
                  </div>
                  <button
                    type="button"
                    className="butn_al_areea1"
                    onClick={handleSaveAdditionalInfo}
                    disabled={saving}
                  >
                    Save Additional Info
                  </button>
                </div>

                {loading && (
                  <p style={{ opacity: 0.7, marginTop: 12 }}>
                    Loading tax info…
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 🔹 Modals */}
      {showTaxInfo && (
        <TaxInfoModal
          onClose={() => setShowTaxInfo(false)}
          initialValues={tax}
          onSubmit={(values) =>
            saveTax({ ...tax, tax_country: ensureTaxCountry(values.tax_country) })
          }
        />
      )}

      {showVAT && (
        <VatIdModal
          onClose={() => setShowVAT(false)}
          initialValues={tax}
          onSubmit={(values) =>
            saveTax({ ...tax, ...values, tax_country: ensureTaxCountry(tax.tax_country) })
          }
        />
      )}
    </>
  );
}

export default HostTaxes;
